import { DataButton } from "@sellar-io/components";
import { TableInputContainer } from "../../../../components/tableInputContainer/TableInputContainer";
import { twMerge } from "tailwind-merge";
import { InputSelect, InputOption } from "@sellar-io/components";
import { usePayoutStore, PayoutStoreState } from "../stores/PayoutFilterStore";
import { useShallow } from "zustand/react/shallow";

export const PayoutFilter = ({
  onDismiss,
  isMobile,
}: {
  onDismiss: () => void;
  isMobile?: boolean;
}) => {
  const { documentType, setDocumentType, reset } = usePayoutStore(
    useShallow((state: PayoutStoreState) => state),
  );

  const filtersApplied = documentType !== "all";
  const disabled = documentType === "all";

  const onApply = (resetFilter: boolean) => {
    if (resetFilter) {
      reset();
    }
    onDismiss();
  };

  return (
    <div>
      <div
        className={twMerge(
          "w-full",
          isMobile ? "px-4 pt-2" : "border-b border-zinc-300 p-4",
        )}
      >
        <span className="font-semibold">Filter Payouts by Document Type</span>
      </div>
      <div className="w-full p-4">
        <div className="flex flex-col gap-3">
          {/* Document type filter */}
          <div className="flex w-full items-center justify-between gap-3">
            <div className="flex shrink-0">Document Type</div>
            <div className="w-[55%]">
              <TableInputContainer>
                <InputSelect
                  defaultValue={documentType}
                  onChange={(e) =>
                    setDocumentType(
                      e.target.value as
                        | "all"
                        | "invoice"
                        | "fee"
                        | "credit-note",
                    )
                  }
                  className="text-sm font-medium"
                >
                  <InputOption value="all">All</InputOption>
                  <InputOption value="invoice">Invoice</InputOption>
                  <InputOption value="fee">Fee</InputOption>
                  <InputOption value="credit-note">Credit note</InputOption>
                </InputSelect>
              </TableInputContainer>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center gap-2 p-4">
        <DataButton
          onClick={() => onApply(false)}
          border={true}
          disabled={disabled}
        >
          Apply
        </DataButton>
        {filtersApplied && (
          <DataButton color="transparent" onClick={() => onApply(true)}>
            Clear all
          </DataButton>
        )}
      </div>
    </div>
  );
};
